<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">T<span class="smallcaps">HE</span> B<span class="smallcaps">ATTLE</span></p>
<p class="half1"><span class="smallcaps">OF</span></p>
<p class="half2">J<span class="smallcaps">ACKSON</span>,</p>
<p class="half1">M<span class="smallcaps">ISSISSIPPI</span></p>
<p class="half3">M<span class="smallcaps">AY</span> 14, 1863</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?33a26c8c